import React, { useState, useEffect } from "react";
import Grid from "../../Grid/Grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DropDownGrid from "../../Grid/Components/DropDownGrid";
import {
  Box,
  MenuItem,
  ListItemIcon,
  Typography
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import transactionAuditAPI from "../../../Network/TransactionAudit";
import mainUnitApi from "../../../Network/MainUnit";
import { selectRoles } from "../../../reduxStore/RolesReducer";

const cookies = new Cookies();



export default function MainUnitSubscriptionLogs(props) {
  const [t] = useTranslation("common");
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);

  const [pageCount, setPageCount] = useState(0);
  const [openFilterColumn, setOpenFilterColumn] = useState(false);
  const [openFilterColumnValue, setOpenFilterColumnValue] = useState([]);


  const maintheme = useSelector((state) => state.themeData.maintheme);

  const [filters, setFilters] = useState({
    name: "",
    code: "",
    type_id: null,
    wialon_id: null,
    export_excel: false
  })
  const [reload, setReload] = useState(false)



  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };
  const navigate = useNavigate();
  const controller = new AbortController();
  const [rowsTotal, setRowsTotal] = useState(0);
  const screenwidth = useSelector((state) => state.settingsData.screenwidth);

  const rolesRedux = useSelector(selectRoles)

  const columns = [
    { field: "index_column", headerName: "ت", minWidth: 50, maxWidth: 60 },
    // { field: "id", headerName: "#", minWidth: 50, maxWidth: 60 },
    { field: "is_subscribed_name", headerName: t("UNITS.is_subscribed"), flex: 1 },
    { field: "is_subscribed_note", headerName: t("UNITS.is_subscribed_note"), flex: 2 },
    { field: "created_by_name", headerName: t("UNITS.created_by_name"), flex: 1 },
    { field: "formatted_datetime", headerName: t("UNITS.created_at"), flex: 1 },

  ]





  useEffect(() => {
    loadData()
  }, [pageNumber, pageSize, reload, props?.reload]);

  const loadData = async (searchParams) => {
    console.log("searchParams", searchParams);

    const headerObject = {
      username: cookies.get("user_name") ? cookies.get("user_name") : null,
      user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
      account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
      account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
      authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
      sid: cookies.get("sid") ? cookies.get("sid") : null,
      baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
      id: cookies.get("id") ? cookies.get("id") : null,
    }
    if (!props?.mainUnitId) {
      return
    }
    if (
      cookies.get("active_session") &&
      cookies.get("active_session") == "yes"
    ) {
      let object = {
        ...headerObject,
        ...(filters?.export_excel ? {} :
          {
            page: pageNumber,
            page_size: pageSize,
          }),
        search: "",
        ...searchParams,
        ...filters,
        main_unit_id: props?.mainUnitId,
      };

      setLoading(true);

      const result = await mainUnitApi.mainUnitSubscriptionLogs({
        params: object,
        signal: controller?.signal,
      });
      setLoading(false);

      if (result.status && result?.data?.data) {



        if (result?.data?.data?.data?.length > 0) {
          setRows(result?.data?.data?.data);
          setRowsTotal(result?.data?.data?.total_records);
          setPageCount(Math.ceil(result?.data?.data?.total_records / pageSize));
        }
        else {
          setRows([]);
          setRowsTotal(0);
          setPageCount(0);
        }


      } else {

        if (result?.data?.data?.message) {
          toast.error(result?.data?.data?.message?.text ? result?.data?.data?.message?.text : result?.data?.data?.message)
        }
        else if (!result?.data?.error) {
          toast.error(t("NETWORK_MESSAGES.unknownError"));
          return;
        }
        if (result && result?.data && result?.data?.data?.message) {
          if (result?.data?.data?.message?.text == "unauthorized to complete") {
            navigate("/redirect");
          }
        }
      }
      setLoading(false);
    } else {
      navigate("/redirect");
    }
  };
  const updateFunction = (obj) => {

  }

  const createFunction = (obj) => {

  }


  const clearFilterFunction = () => {
    setFilters({
      name: "",
      code: "",
      type_id: null,
      wialon_id: null,
      export_excel: false
    })
  }
  const searchFunction = () => {
    setReload(!reload)
    setPageNumber(1)
  };

  const exportFunction = () => {

    setFilters({
      ...filters,
      export_excel: true
    })
    setReload(!reload)
  }

  return (

    <Grid
      rows={rows}
      hasExport={rolesRedux?.export_transaction_audit?.value}
      exportFunction={exportFunction}
      columns={columns}
      pageSize={pageSize}
      setPageSize={setPageSize}
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      loading={loading}
      handlePageChange={handlePageChange}
      rowsTotal={rowsTotal}
      checkScreenSize={screenwidth}
      pageCount={pageCount}
      openFilterColumn={openFilterColumn}

      setOpenFilterColumn={setOpenFilterColumn}
      setColumnFilterValue={setOpenFilterColumnValue}
      columFilterValue={openFilterColumnValue}

      clearFunction={clearFilterFunction}
      searchFunction={searchFunction}

      hasCreate={false}
      creatFunction={createFunction}
      notHaveAdvancSearch={true}
      customHeight={'300px'}
      filterChilds={null}
      customContianerSX={{
        padding: 0
      }}
    />
  );
}
